import React from "react";
import prabhat from "../../assets/home/team-images/prabhat-photo.png";
import saurabh from "../../assets/home/team-images/saurabh-photo.jpeg";

const teamMembers = [
  { name: "Mr. Rakesh Kumar", role: "Director", image: "prabhat" },
  { name: "Mr. Avnesh Pratap Singh", role: "Director", image: "prabhat" },
  { name: "Mrs. Sangeeta", role: "CEO", image: "prabhat" },
  { name: "Mrs. Subhi Singh", role: "Legal & Commercial Head", image: "prabhat" },
  { name: "Prabhat Kumar", role: "Software Engineer", image: prabhat },
  { name: "Saurabh Kumar", role: "Frontend Developer", image: saurabh },
];

const OurTeam = () => {
  return (
    <div className="py-8">
      <div className="flex justify-center items-center font-bold text-3xl mb-6">
        <h1>Our Team</h1>
      </div>

      <div className="mx-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 text-center">
        {teamMembers.map((member, index) => (
          <div key={index}>
            <div className="w-52 h-56 mx-auto overflow-hidden rounded-lg border border-cyan-500 shadow-lg">
              <img
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                src={member.image}
                alt={member.name}
              />
            </div>
            <p className="mt-3">
              <b>{member.name}</b> <br /> {member.role}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurTeam;
